module.exports = __webpack_public_path__ + "img/002-shrimp.4cc58335.svg";